import React from "react";
import { NewsData } from "../../../../lib/types";
import { NEWS_DETAIL } from "../../../../lib/enums";
import { formatNumber } from "../../../../lib/commonFunctions";

interface IProps {
  round: NewsData;
}

const NewsPersonRange = ({
  round
}: IProps) => {
  if (!round.details[NEWS_DETAIL.RangePhaseDetail]) {
    return <>Not involved in range phase</>
  }

  const parts = round.details[NEWS_DETAIL.RangePhaseDetail] && round.details[NEWS_DETAIL.RangePhaseDetail].value.split("|");
  const names = parts[0]?.split(":");
  const firstTurn = parts[1]?.split(":");
  const secondTurn = parts[2]?.split(":");

  return (
    <div>
      <p className={"text-info"}>Range phase</p>
      {firstTurn[0] !== "-" && <>
        <em>{names[0]}</em>&nbsp;
        <i
        className={`icon icon-ranged-attack middle ${firstTurn && Number.parseFloat(firstTurn[0]) > 0 ? " positive" : " negative"}`}/>
        &nbsp;
        <em>{names[1]}</em>
        <div style={{ paddingTop: "7px", paddingBottom: "7px" }}>
          <div>
            Damage: <em>{formatNumber(parseInt(firstTurn[0], 10))}</em>
          </div>
        </div>
      </>}
      {firstTurn[1] !== "-" && <>
        <em>{names[1]}</em>&nbsp;
        <i
          className={`icon icon-ranged-attack middle ${firstTurn && Number.parseFloat(firstTurn[1]) > 0 ? " positive" : " negative"}`}/>
        &nbsp;
        <em>{names[0]}</em>
        <div style={{ paddingTop: "7px", paddingBottom: "7px" }}>
          <div>
            Damage: <em>{formatNumber(parseInt(firstTurn[1], 10))}</em>
          </div>
        </div>
      </>}

      {secondTurn && secondTurn[0] !== "-" && <>
        Second turn
        <em>{names[0]}</em>&nbsp;
        <i
          className={`icon icon-ranged-attack middle ${firstTurn && Number.parseFloat(secondTurn[0]) > 0 ? " positive" : " negative"}`}/>
        &nbsp;
        <em>{names[1]}</em>
        <div style={{ paddingTop: "7px", paddingBottom: "7px" }}>
          <div>
            Damage: <em>{formatNumber(parseInt(secondTurn[0], 10))}</em>
          </div>
        </div>
      </>}
      {secondTurn && secondTurn[1] !== "-" && <>
        Second turn
        <em>{names[1]}</em>&nbsp;
        <i
          className={`icon icon-ranged-attack middle ${firstTurn && Number.parseFloat(secondTurn[1]) > 0 ? " positive" : " negative"}`}/>
        &nbsp;
        <em>{names[0]}</em>
        <div style={{ paddingTop: "7px", paddingBottom: "7px" }}>
          <div>
            Damage: <em>{formatNumber(parseInt(secondTurn[1], 10))}</em>
          </div>
        </div>
      </>}
    </div>
  )
}

export default NewsPersonRange;
